import PropTypes from 'prop-types';
import React from 'react';

import { doc } from 'firebase/firestore';
import { useFirestore } from 'reactfire';

import { useNotifications } from 'components/Notifications/NotificationsProvider';
import { CLASSIFIED_OPPORTUNITIES_COLLECTION } from 'constants/firebasePaths';
import useFirestoreWrapper from 'hooks/useFirestoreWrapper';

import AdminOpportunityCompanies from './AdminOpportunityCompanies';
import AdminOpportunityWrapper from './AdminOpportunityWrapper';

const AdminOpportunity = ({ opportunity = {} }) => {
  const firestore = useFirestore();
  const { companies, targetedCompanies } = opportunity;
  const { updateDocument } = useFirestoreWrapper();

  const ref = doc(
    firestore,
    CLASSIFIED_OPPORTUNITIES_COLLECTION,
    opportunity.uid
  );

  const { showSuccess, showError } = useNotifications();

  const onToggleDelete = async () => {
    const action = opportunity.deleted ? 'recover' : 'delet';
    try {
      await updateDocument(ref, { deleted: !opportunity.deleted });
      showSuccess({ message: `Opportunity ${action}ed successfully.` });
    } catch (err) {
      showError({ message: `Error ${action}ing opportunity: ${err.message}` });
    }
  };

  return (
    <AdminOpportunityWrapper
      onToggleDelete={onToggleDelete}
      opportunity={opportunity}
      Companies={
        <AdminOpportunityCompanies
          companies={companies}
          targetedCompanies={targetedCompanies}
          opportunityUid={opportunity.uid}
        />
      }
    />
  );
};

AdminOpportunity.propTypes = {
  opportunity: PropTypes.object,
};

export default AdminOpportunity;
